<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100vw;min-height: 100vh;display: flex;flex-direction: column;background-color: white;">
    <!-- 头部 -->
    <div
      style="width: 100vw;height: 6vh;background-color: rgb(52,31,18);display: flex;align-items: center;justify-content: center;">
      <img src="/static/images/jiuzan/usercenter.png" style="width: 19vw;display: block;" />
    </div>

    <!-- Banner区域 -->
    <div id="bannerbg"
      style="width: 100vw;height: 26vh;background: url(/static/images/jiuzan/bannerbg.png) center center / cover no-repeat;display: flex;flex-direction: column;align-items: center;">
      <img src="/static/images/jiuzan/logo.png" style="width: 30vw;display: block;margin-top: 2vh;" />
      <img src="/static/images/jiuzan/city.png" style="width: 70vw;display: block;margin-top: 1vh;" />
    </div>


    <!-- 查询结果区域-正品 -->
    <div v-if="isError == 2"
      style="width: 100vw;flex: 1;background-color: white;display: flex;flex-direction: column;align-items: center;padding: 4vh 5vw;">
      <!-- 查询码 -->
      <div
        style="width: 100%;text-align: center;font-size: 5vw;font-weight: bold;color: #333;margin-top: 2vh;letter-spacing: 1px;">
        {{ antiCode }}
      </div>

      <!-- 正品信息 -->
      <div style="width: 100%;text-align: center;margin-top: 4vh;font-size: 4.5vw;color: #333;">
        <span>您所查询的是</span><span style="color: rgb(96,21,7);font-weight: bold;">{{ productName }}</span><span>正品</span>
      </div>

      <!-- 积分信息 -->
      <div v-if="isNewJoin==1" style="width: 100%;display: flex;justify-content: center;align-items: baseline;margin-top: 3vh;">
        <div style="font-size: 4.5vw;color: #333;">恭喜获得:</div>
        <div style="color: rgb(96,21,7);font-weight:bold;font-size: 10vw;margin: 0 1vw;line-height: 1;">{{ points }}
        </div>
        <div style="font-size: 4.5vw;color: #333;">积分</div>
      </div>

      <div v-if="isNewJoin==2" style="width: 100%;display: flex;justify-content: center;align-items: baseline;margin-top: 3vh;">
        <div style="font-size: 4.5vw;color: #333;">此数码已参与过活动</div>
      </div>

      <!-- 扫码历史 -->
      <div
        style="width: 100%;margin-top: 5vh;display: flex;flex-direction: column;align-items: flex-start;padding-left: 10vw;">
        <div style="display: flex;align-items: center;margin-bottom: 2vh;">
          <img src="/static/images/jiuzan/scanicon.png" style="width: 5vw;height: 5vw;margin-right: 2vw;" />
          <span style="font-size: 4vw;color: #333;">扫码次数: {{ scanCount }}</span>
        </div>
        <div style="font-size: 3.5vw;color: #666;margin-left: 7vw;margin-bottom: 1vh;">
          首次扫码: {{ firstScanTime }}
        </div>
        <div style="font-size: 3.5vw;color: #666;margin-left: 7vw;">
          最近扫码: {{ preQueryTime }}
        </div>
      </div>
    </div>




    <!-- 查询结果区域-非正品 -->
    <div v-if="isError == 1"
      style="width: 100vw;flex: 1;background-color: white;display: flex;flex-direction: column;align-items: center;padding: 4vh 5vw;">
      <!-- 查询码 -->
      <div
        style="width: 100%;text-align: center;font-size: 5vw;font-weight: bold;color: #333;margin-top: 2vh;letter-spacing: 1px;">
        {{ antiCode }}
      </div>

      <!-- 异常信息 -->
      <div style="width: 100%;text-align: center;margin-top: 10vh;font-size: 4.5vw;color: #333;">
        <span>您所查询的数码不存在</span>
      </div>
      <div style="width: 100%;text-align: center;margin-top: 1vh;font-size: 4.5vw;color: #333;">
        <span>谨防假冒请核对后重新输入</span>
      </div>
    </div>





    <!-- 底部按钮 前往商城兑换好礼-->
    <div v-if="isError == 2"
      style="width: 100vw;display: flex;justify-content: center;align-items: center;padding: 0.5vh 5vw 6vh 5vw;background-color: white;">
      <div style="position: relative;width: 75vw;display: flex;justify-content: center;">
        <img v-if="isNewJoin==0" src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/djlqjf-5e4e49908b.png" 
        style="width: 100%;height: auto;display: block;" />

        <wx-open-launch-weapp v-if="isNewJoin!=0" id="launch-btn"
          style="position: relative;width: 75vw;" 
          :appid="miniAppId" :username="miniAppOriginalId" :path="miniAppPage">
          <script type="text/wxtag-template">
              <img src="https://zishu-image.oss-cn-shanghai.aliyuncs.com/djscdh-1e50c86b58f.png" 
              style="width: 100%;height: auto;display: block;" />
          </script>
        </wx-open-launch-weapp>
        
        <div v-if="isNewJoin==0" @click="toJoinActivity"
          style="position: absolute;right: 0;top: 0;width: 20%;height: 100%;cursor: pointer;z-index: 10;">
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped></style>

<script>
import { queryAnti, getInfoByCode, registerByOpenId, joinActivity, getTemplate, getScoreConfig,getWechatAuth,getJSSDK } from '../../api/api'
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      eno: "138735818115",
      authCode: "",
      isNewJoin: 0,
      resultShow: false,
      activityId:0,
      shopUrl:"",
      isError: 0,
      isJoining: false, // 防止重复参与活动的标志位
      deptId: 0,
      antiCode: "",
      productNo: "",
      productName: "",
      points: "", // 积分，需要从API获取
      scanCount: "", // 扫码次数，需要从API获取
      firstScanTime: "", // 首次扫码时间
      preQueryTime: "", // 最近扫码时间
      miniAppId: "",
      miniAppOriginalId: "",
      miniAppPage: "",
    }
  },
  methods: {
    formatTime(timeStr) {
      if (!timeStr) return ""
      // 格式化时间字符串，例如：2025-11-16 17:00:00
      return timeStr.replace(/T/g, ' ').substring(0, 19)
    },
    // 保存查询结果到缓存
    saveToCache() {
      const cacheKey = `anti_query_cache_${this.antiCode}_${this.eno}`
      const cacheData = {
        isError: this.isError,
        deptId: this.deptId,
        firstScanTime: this.firstScanTime,
        preQueryTime: this.preQueryTime,
        scanCount: this.scanCount,
        productNo: this.productNo,
        productName: this.productName,
        timestamp: Date.now()
      }
      sessionStorage.setItem(cacheKey, JSON.stringify(cacheData))
    },
    // 从缓存中恢复查询结果
    restoreFromCache() {
      const cacheKey = `anti_query_cache_${this.antiCode}_${this.eno}`
      const cachedData = sessionStorage.getItem(cacheKey)
      if (cachedData) {
        try {
          const data = JSON.parse(cachedData)
          this.isError = data.isError
          this.deptId = data.deptId
          this.firstScanTime = data.firstScanTime
          this.preQueryTime = data.preQueryTime
          this.scanCount = data.scanCount
          this.productNo = data.productNo
          this.productName = data.productName
          return true
        } catch (e) {
          console.error('恢复缓存数据失败:', e)
          return false
        }
      }
      return false
    },
    // 清理缓存
    clearCache() {
      const cacheKey = `anti_query_cache_${this.antiCode}_${this.eno}`
      sessionStorage.removeItem(cacheKey)
    },
    async getResult() {
      // 优先从缓存中恢复数据
      const wechatAuth = sessionStorage.getItem("wechatAuth")
      const isWechatCallback = this.authCode != null && this.authCode != "" && this.authCode != undefined && wechatAuth == "true"
      
      if (isWechatCallback) {
        const restored = this.restoreFromCache()
        if (restored) {
          console.log('从缓存恢复查询结果，跳过防伪查询')
          // 如果缓存中没有产品信息，才调用 queryCodeInfo
          if (!this.productName && !this.productNo) {
            await this.queryCodeInfo(this.eno, this.antiCode)
          }
          // 恢复数据后，继续执行后续逻辑（如参与活动）
          // 如果已经参与过活动（isNewJoin不为0），则不再调用
          if (this.isError == 2 && this.isNewJoin == 0 && !this.isJoining) {
            this.toJoinActivity()
          }
          return
        }
      }

      // 正常查询流程
      var res = await queryAnti(this.antiCode, this.eno)
      var data = res.data
      if (data == null || data.code == "500") {
        alert("查询异常，请重新输入防伪码进行查询")
        this.isError = 1
      } else {

        var replyCode = data.data.replyCode

        if (replyCode === "300101" || replyCode == "300102") {
          this.isError = 2
          if (data.data.firstQueryTime) {
            this.firstScanTime = this.formatTime(data.data.firstQueryTime)
            this.preQueryTime = this.formatTime(data.data.firstQueryTime)
          }
          if (data.data.preQueryTime) {
            this.preQueryTime = this.formatTime(data.data.preQueryTime)
          }
          this.scanCount = data.data.queryCount
          this.deptId = data.data.deptId
          
          await this.queryCodeInfo(this.eno, this.antiCode)
          
          // 保存查询结果到缓存（在获取产品信息后）
          this.saveToCache()

          // 如果用户已经授权，则参与活动
          // 如果已经参与过活动（isNewJoin不为0），则不再调用
          if (isWechatCallback && this.isNewJoin == 0 && !this.isJoining) {
            this.toJoinActivity()
          }

        } else if (replyCode == "300106") {
          this.isError = 1
        }
      }
    },
    async queryCodeInfo(eno, code) {
      var res = await getInfoByCode(code)
      console.log('查询的码结果为：', res)
      var data = res.data
      if (data.code == "200" && data.data != null) {
        this.productNo = data.data.productNo || ""
        this.productName = data.data.productName || ""
        
      }
    },
    async toJoinActivity() {
      // 防止重复调用
      if (this.isJoining || this.isNewJoin != 0) {
        console.log('活动参与中或已参与，跳过重复调用')
        return
      }

      this.isJoining = true
      
      try {
        await this.getScoreConfig()
        await this.getTemplate();

        if (this.activityId > 0) {
          if (this.authCode == undefined || this.authCode == "" || this.authCode == null) {
            // 确保产品信息已获取，如果还没有则先获取
            if (!this.productName && !this.productNo) {
              await this.queryCodeInfo(this.eno, this.antiCode)
            }
            // 在调用 getAuth 之前保存缓存（确保数据完整）
            this.saveToCache()
            // 调用 getAuth 会跳转页面，不需要重置 isJoining
            this.getAuth()
          } else {
            try {
              const res = await registerByOpenId(this.eno, this.authCode);
              if (res != null && res.data != null && res.data.data != null) {
                this.userToken = res.data.data.token;
                var data = {
                  code: this.antiCode,
                  activityId: this.activityId,
                  authCode: this.authCode,
                  userToken: this.userToken
                }
                const ret = await joinActivity(data);
                if (ret.data.code == "200") {
                  this.isNewJoin = 1
                  this.points = ret.data.data.giftValue
                  this.resultShow = true
                } else if (ret.data.code == "500001") {
                  this.isNewJoin = 2
                  this.resultShow = true
                } else {
                  alert("参与营销活动失败")
                }
              } else {
                alert("注册用户失败，请重试")
              }
            } catch (error) {
              console.error('参与活动失败:', error)
              alert("参与活动失败，请重试")
            } finally {
              // 无论成功或失败，都清理微信授权标记和缓存
              sessionStorage.removeItem("wechatAuth");
              this.clearCache()
              // 重置参与活动标志位
              this.isJoining = false
            }
          }
        } else {
          // activityId 为 0 时，重置标志位
          this.isJoining = false
        }
      } catch (error) {
        console.error('获取活动配置失败:', error)
        this.isJoining = false
      }
    },
    getAuth() {
      const url = window.location.href.split('#')[0];
      sessionStorage.setItem("wechatAuth", true);
      getWechatAuth(url, "wx7e8df2f40063c010", 1).then(res => {
        const data = res.data;
        window.location.href = data;
      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    },
    async getTemplate() {
      var res = await getTemplate(this.deptId)

      if (res != null && res.data.data != null) {
        this.activityId = res.data.data.activityId;
      }
    },
    async getScoreConfig() {
      var res = await getScoreConfig(this.deptId);
      if (res != null && res.data.data != null) {
        this.shopUrl = res.data.data.shopUrl
        const data = this.shopUrl.split('|')
        this.miniAppId = data[0]
        this.miniAppOriginalId = data[1]
        this.miniAppPage = data[2]
      }

    },
    getWxJs() {
      const url = encodeURIComponent(window.location.href.split('#')[0])
      getJSSDK(url, "wx7e8df2f40063c010").then(res => {
        const data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.appId, // 必填，公众号的唯一标识
          timestamp: data.timestamp, // 必填，生成签名的时间戳
          nonceStr: data.nonceStr, // 必填，生成签名的随机串
          signature: data.signature,// 必填，签名，见附录1
          openTagList: ["wx-open-launch-weapp", "wx-open-launch-app"],
          jsApiList: [
            'checkJsApi',
            'onMenuShareTimeline',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            'hideMenuItems',
            'showMenuItems',
            'hideAllNonBaseMenuItem',
            'showAllNonBaseMenuItem',
            'translateVoice',
            'startRecord',
            'stopRecord',
            'onVoiceRecordEnd',
            'playVoice',
            'onVoicePlayEnd',
            'pauseVoice',
            'stopVoice',
            'uploadVoice',
            'downloadVoice',
            'chooseImage',
            'previewImage',
            'uploadImage',
            'downloadImage',
            'getNetworkType',
            'openLocation',
            'getLocation',
            'hideOptionMenu',
            'showOptionMenu',
            'closeWindow',
            'scanQRCode',
            'chooseWXPay',
            'openProductSpecificView',
            'addCard',
            'chooseCard',
            'openCard'
          ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        wx.ready(function () {
          wx.hideMenuItems({
            menuList: [
              'menuItem:copyUrl',
              'menuItem:openWithQQBrowse',
              'menuItem:openWithSafari',
              'menuItem:email',
              'menuItem:readMode',
              'menuItem:originPage',
              'menuItem:delete',
              'menuItem:editTag'
            ]
          });
        });

      }).catch(err =>
        alert("获取微信授权失败" + err)
      )
    }
  },
  mounted: function () {
    const params = this.$route.query
    var antiCode = params.c
    this.authCode = params.wyAuthCode
    this.antiCode = antiCode
    if (antiCode == null || antiCode == undefined) {
      alert("请从正确的入口进入查询")
      this.isError = 1
    } else {
      this.getWxJs()
      this.getResult()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/JiuZan/Query.vue